import { useState } from "react";

import { getAllOrders } from "../../services/orderApi";
import {
  addOrderStatus,
  getOrderStatusHistory,
} from "../../services/orderStatusApi";

const OrderStatusManager = () => {
  const [orderInput, setOrderInput] = useState("");

  const [order, setOrder] = useState(null);
  const [history, setHistory] = useState([]);

  const [status, setStatus] = useState("");
  const [note, setNote] = useState("");
  const [visible, setVisible] = useState(true);

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  // =========================
  // SEARCH ORDER BY ID
  // =========================
  const handleSearch = async () => {
    if (!orderInput) return alert("Enter Order ID");

    try {
      setLoading(true);
      setMsg("");

      const orders = await getAllOrders();

      const found = orders.find(
        (o) =>
          o.order_id === orderInput ||
          o.id === Number(orderInput)
      );

      if (!found) {
        setOrder(null);
        setHistory([]);
        return setMsg("❌ Order not found");
      }

      setOrder(found);

      const historyData = await getOrderStatusHistory(found.id);
      setHistory(historyData || []);
    } catch (err) {
      setMsg("❌ Failed to fetch order");
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // UPDATE STATUS
  // =========================
  const handleUpdate = async () => {
    if (!order?.id) return setMsg("❌ Search order first");
    if (!status) return setMsg("❌ Select status");

    try {
      setLoading(true);

      await addOrderStatus(order.id, {
        status,
        note,
        is_visible_to_user: visible,
      });

      setMsg("✅ Status updated");

      setStatus("");
      setNote("");

      const historyData = await getOrderStatusHistory(order.id);
      setHistory(historyData || []);
    } catch (err) {
      setMsg("❌ Update failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>📦 Order Status Manager</h2>

      {/* ================= SEARCH BAR ================= */}
      <div style={{ marginBottom: "20px" }}>
        <input
          placeholder="Enter Order ID (e.g. ORD-123 or 1)"
          value={orderInput}
          onChange={(e) => setOrderInput(e.target.value)}
          style={{ padding: "8px", width: "250px" }}
        />

        <button
          onClick={handleSearch}
          style={{ marginLeft: "10px", padding: "8px 15px" }}
        >
          Search
        </button>
      </div>

      {loading && <p>Loading...</p>}
      {msg && <p>{msg}</p>}

      {/* ================= ORDER DETAILS ================= */}
      {order && (
        <div style={{ background: "#f1f5f9", padding: "15px" }}>
          <h3>📦 Order Details</h3>

          <p><b>Order ID:</b> {order.order_id}</p>
          <p><b>Name:</b> {order.user_name}</p>
          <p><b>Phone:</b> {order.user_phone}</p>
          <p><b>Status:</b> {order.status}</p>

          <p>
            <b>Time:</b>{" "}
            {order.created_at
              ? new Date(order.created_at).toLocaleString()
              : "-"}
          </p>
        </div>
      )}

      {/* ================= HISTORY ================= */}
      {order && (
        <div style={{ marginTop: "20px" }}>
          <h3>📜 Status History</h3>

          {history.length === 0 ? (
            <p>No history found</p>
          ) : (
            <ul>
              {history.map((h, i) => (
                <li key={i}>
                  <b>{h.status}</b> -{" "}
                  {h.created_at
                    ? new Date(h.created_at).toLocaleString()
                    : ""}{" "}
                  {h.note && `(${h.note})`}
                </li>
              ))}
            </ul>
          )}
        </div>
      )}

      {/* ================= UPDATE STATUS ================= */}
      {order && (
        <div style={{ marginTop: "20px" }}>
          <h3>⚙️ Update Status</h3>

          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            style={{ padding: "8px" }}
          >
            <option value="">Select Status</option>
            <option value="processing">Processing</option>
            <option value="shipped">Shipped</option>
            <option value="delivered">Delivered</option>
          </select>

          <br />

          <textarea
            placeholder="Add note (optional)"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            style={{ width: "300px", height: "80px", marginTop: "10px" }}
          />

          <br />

          <label>
            <input
              type="checkbox"
              checked={visible}
              onChange={(e) => setVisible(e.target.checked)}
            />
            Visible to customer
          </label>

          <br />

          <button
            onClick={handleUpdate}
            style={{ marginTop: "10px", padding: "8px 15px" }}
          >
            Update Status
          </button>
        </div>
      )}
    </div>
  );
};

export default OrderStatusManager;